document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('.scroll-down');
  const sections = Array.from(document.querySelectorAll('section'));
  if (!button) return;

  const updateButtonVisibility = () => {
    const lastSection = sections[sections.length - 1];
    const rect = lastSection.getBoundingClientRect();
    const sectionMiddle = rect.top + rect.height / 2;

    button.classList.toggle('hidden', sectionMiddle <= window.innerHeight);
  };

  button.addEventListener('click', () => {
    const currentIndex = sections.findIndex(section => {
      const rect = section.getBoundingClientRect();

      const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);

      return visibleHeight / rect.height > 0.1;
    });

    const nextSection = sections[currentIndex + 1];
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  });

  window.addEventListener('scroll', updateButtonVisibility);
  window.addEventListener('resize', updateButtonVisibility);

  updateButtonVisibility();
});
